import React from 'react';

interface CircleProps {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const CircleIcon = function CircleIcon({
  className,
  width,
  height,
  color,
}: CircleProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
    >
      <circle cx="8" cy="8" r="8" fill={color} />
    </svg>
  );
};

CircleIcon.defaultProps = {
  className: '',
  width: 16,
  height: 16,
  color: '#F9C371',
};

export default CircleIcon;
